<template>
	<div>
		<el-button class="add-btn-2" type="primary" plain @click="Submit">{{text}}</el-button>
	</div>
</template>

<script lang="ts" setup>
	import { defineEmits, defineProps } from 'vue';
	
	defineProps({
		text: {
			type: String,
			default: ""
		}
	})
	
	const emits = defineEmits(["change"]);
	
	const Submit = () => {
		emits("change");
	};
</script>

<style lang="scss" scope>
	.add-btn-2 {
		padding-left: 20px;
		padding-right: 20px;
		height: 36px;
		border-radius: 4px;
		font-size: 14px;
		line-height: 36px;
	}
</style>